module.exports = __webpack_public_path__ + "static/media/mobile_small_banner.ab7248cd.jpg";